import { useRef } from 'react';
import {
  ILocDiner,
  ISearchParams,
  ISearchResults,
  SearchStatus,
  useGroupDinersSearch,
} from 'src/utilities/useSearchHooks';

export const MEAL_CREDIT_DINERS_PAGE_SIZE = 20;
export const defaultMealCreditDinerSearchParams: ISearchParams = {
  size: MEAL_CREDIT_DINERS_PAGE_SIZE,
  page: 1,
};

export interface UseMealCreditDinerSearch
  extends Omit<ISearchResults<ILocDiner>, 'doSearch'> {
  isLoading: boolean;
  searchDinersByQuery: (query: string) => Promise<void>;
  pageChange: (page: number) => void;
}

export interface UseMealCreditDinerSearchProps {
  corpId: string;
  mealCreditId: string;
}

export const useMealCreditDinerSearch = ({
  corpId,
  mealCreditId,
}: UseMealCreditDinerSearchProps): UseMealCreditDinerSearch => {
  const { doSearch, ...props } = useGroupDinersSearch(corpId, mealCreditId);
  const isLoading = props.searchStatus === SearchStatus.LOADING;
  const currentSearchParams = useRef<ISearchParams>(
    defaultMealCreditDinerSearchParams
  );

  async function searchDiners({
    query,
    ...params
  }: Partial<ISearchParams> = {}): Promise<void> {
    currentSearchParams.current = {
      ...params,
      ...(query && { query }),
    };

    await doSearch(currentSearchParams.current);
  }

  async function searchDinersByQuery(query = ''): Promise<void> {
    await searchDiners({ ...currentSearchParams.current, query, page: 1 });
  }

  async function pageChange(page: number): Promise<void> {
    await searchDiners({ ...currentSearchParams.current, page });
  }

  return {
    ...props,
    isLoading,
    searchDinersByQuery,
    pageChange,
  };
};
